import { Injectable } from "@angular/core";
import { ConnectionBackend, RequestOptions, Request, RequestOptionsArgs, Response, Http, Headers } from "@angular/http";
import { Observable } from "rxjs/Rx";
import { environment } from "../../environments/environment";
import swal from 'sweetalert2';
import { CommonService } from "./common.service";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";


@Injectable()
export class InterceptedHttp extends Http {
  constructor(backend: ConnectionBackend, defaultOptions: RequestOptions, private common?: CommonService) {
    super(backend, defaultOptions);
  }

  request(url: string | Request, options?: RequestOptionsArgs): Observable<Response> {
    return super.request(url, options)
      .catch(this.onCatch)
      .do((res: Response) => {
        this.onSubscribeSuccess(res);
      }, (error: any) => {
        this.onSubscribeError(error);
      })
      .finally(() => {
        this.onFinally();
      });
  }

  get(url: string, options?: RequestOptionsArgs): Observable<Response> {
    url = this.updateUrl(url);
    return super.get(url, this.getRequestOptionArgs(options))
      .catch(this.onCatch)
    .map((res)=>{
        let d = this.onSubscribeSuccess(res);
        if(d){
            res['_body'] = d;
            return res;
        }
        else
            return res;
    })
      .do((res: Response) => {
//        let d = this.onSubscribeSuccess(res);
//        console.log(121212, d)
//        if(d)
//            res = d;
      }, (error: any) => {
        this.onSubscribeError(error);
      })
      .finally(() => {
        this.onFinally();
      });
  }

  post(url: string, body: string, options?: RequestOptionsArgs): Observable<Response> {
    url = this.updateUrl(url);
    return super.post(url, body, this.getRequestOptionArgs(options))
      .catch(this.onCatch)
    .map((res)=>{
        let d = this.onSubscribeSuccess(res);
        if(d){
            res['_body'] = d;
            return res;
        }
        else
            return res;
    })
      .do((res: Response) => {
//        this.onSubscribeSuccess(res);
      }, (error: any) => {
        this.onSubscribeError(error);
      })
      .finally(() => {
        this.onFinally();
      });
  }

  put(url: string, body: string, options?: RequestOptionsArgs): Observable<Response> {
    url = this.updateUrl(url);
    return super.put(url, body, this.getRequestOptionArgs(options))
      .catch(this.onCatch)
    .map((res)=>{
        let d = this.onSubscribeSuccess(res);
        if(d){
            res['_body'] = d;
            return res;
        }
        else
            return res;
    })
      .do((res: Response) => {
//        this.onSubscribeSuccess(res);
      }, (error: any) => {
        this.onSubscribeError(error);
      })
      .finally(() => {
        this.onFinally();
      });
  }

  delete(url: string, options?: RequestOptionsArgs): Observable<Response> {
    url = this.updateUrl(url);
    return super.delete(url, this.getRequestOptionArgs(options))
      .catch(this.onCatch)
    .map((res)=>{
        let d = this.onSubscribeSuccess(res);
        if(d){
            res['_body'] = d;
            return res;
        }
        else
            return res;
    })
      .do((res: Response) => {
//        this.onSubscribeSuccess(res);
      }, (error: any) => {
        this.onSubscribeError(error);
      })
      .finally(() => {
        this.onFinally();
      });
  }

  private updateUrl(req: string) {
    return req;
  }

  private getRequestOptionArgs(options?: RequestOptionsArgs): RequestOptionsArgs {
    if (options == null) {
      options = new RequestOptions();
    }
    if (options.headers == null) {
      options.headers = new Headers();
    }
    options.headers.append('Content-Type', 'application/json');

    return options;
  }
  private onCatch(error: any, caught: Observable<any>): Observable<any> {
    return Observable.throw(error);
  }

  /**
   * onSuccess
   * @param res
   */
  logoutStatus = false;
  private onSubscribeSuccess(res: Response) {
    // Pending
    if(res['_body'] instanceof Blob) {
      if(res['_body']['type'] == 'application/json' ) {
        console.log("going in");
        let result = {};
        const reader = new FileReader();

        // This fires after the blob has been read/loaded.
        reader.addEventListener('loadend', (e) => {
          const text = e.currentTarget;
          result = JSON.parse(text['result']);
          if(result['message'].startsWith('Unauthorized Access')){
            this.logoutStatus = true;
            this.common.callLogout("logout by session timeout");
            swal(
              'Error!',
              "Session Expired!",
              'error'
            ).then(() => {
            }, () => {
            });
          } else{
            swal(
              "Unable to proceess your request. Please try after sometime."
            ).then(() => {
            }, () => {
            });
          }

        });

        // Start reading the blob as text.
        reader.readAsText(res['_body'])
        // if(res['status'] == 412){

        // }
        // if(!this.logoutStatus) {
        //   this.logoutStatus = true;
        //   this.common.callLogout("logout by session timeout");
        // }


        // return {status:"failed", message: "Session Timeout"};
      } else {
        this.logoutStatus = false;
      }
    } else {
      this.logoutStatus = false;
    }

    try {
      if (res && res['_body'] && typeof res['_body'] === 'string') {
        let result = res['_body'];
        try {
          do {
              result = JSON.parse(result);
          } while (typeof result != "object")
        } catch (e) {
          console.log("http intercepter parse log", e);
        }

        if (result['status'] == "failed" && result['status_code'] === 401) { console.log("inside self");
          if(!this.logoutStatus) {
              this.logoutStatus = true;
              this.common.callLogout("logout by session timeout");
          }
          return {status:"failed", message: "Session Timeout"};
        } else {
            this.logoutStatus = false;
        }
        // if(result.mfsCommonServiceResponse) { console.log("inside core");
        //   if (result.mfsCommonServiceResponse.mfsStatusInfo.errorCode == 120 && result.mfsCommonServiceResponse.mfsStatusInfo.errorDescription.startsWith('Unauthorized Access')) {

        if (result['status_code'] === 120 && result['message'].startsWith('Unauthorized Access')) {
        if(!this.logoutStatus) {
              this.logoutStatus = true;
              this.common.callLogout("logout by session timeout");
            }
            return {
              status:"failed",
              message: "Session Expired !!!"
            };
          } else {
            this.logoutStatus = false;
          }
        // }

      }
    } catch (e) {
      console.log(e)
    }
    return null;
  }

  /**
   * onError
   * @param error
   */
  private onSubscribeError(error: any): void {
    swal({
      title: error.statusText + " " + error.status,
      type: 'error'
    }).then((s) => { }, (e) => { });


  }

  /**
   * onFinally
   */
  private onFinally(): void {
  }
}



// WEBPACK FOOTER //
// /Users/ldt/Desktop/afropay_admin/afropay-admin-frontend/src/app/common/intercepted-http.service.ts